import Modal from 'components/Layout/Modal';
import DetailItem from 'components/Layout/DetailItem';
import ActionForm from '../../../Common/ActionForm';
import {
  getDataFromLocalStorage,
  getEventDate,
  getStatus,
  getStatusColor,
  handleFileDownload,
} from 'utils/helpers';
import Button from 'components/form/Button';
import { requestDataPath } from 'utils/constants';

const ActionFormPopup = ({
  initialValues,
  isRejecting,
  setIsRejecting,
  handleReject,
  handleApproveRequest,
  onHide,
  handleView,
  data,
  isLoading,
}) => {
  const user_type = getDataFromLocalStorage('user_type');
  const {
    resource_data,
    admin_data,
    sadmin_data,
    event_type,
    event_name,
    event_start_date,
    event_end_date,
    event_city,
    event_county,
    certificate_file,
  } = data;
  const isAdmin = user_type === '0';
  const isSuperAdmin = user_type === '1';
  const isActionTakenByAdmin = data.admin_data.admin_status !== '0';
  const isActionTakenBySuperAdmin = data.sadmin_data.sadmin_status !== '0';

  return (
    <Modal
      onHide={onHide}
      size="xl"
      titleBesideClose="Research Paper Presentation Certificate"
      isTitleBorder
      isTitleVerticalCenter
      titleBesideCloseClassName={'text-18-300 color-1717'}
    >
      <div className="cps-32 cpt-20 cpe-32 cpb-20">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-12">
            <DetailItem label="Event Name" value={event_name} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-6 col-12">
            <DetailItem label="Event Type" value={event_type} />
          </div>
          <div className="col-md-3 col-sm-6 col-12">
            <DetailItem
              label="Event Date"
              value={getEventDate(event_start_date, event_end_date)}
            />
          </div>
          <div className="col-md-3 col-sm-6 col-12">
            <DetailItem label="Place" value={`${event_city},${event_county}`} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-lg-3 col-sm-6 col-12">
            <DetailItem label="Added By" value={resource_data?.name} />
          </div>

          <div className="col-md-4 col-lg-3 col-sm-6 col-12">
            <DetailItem label="Id" value={resource_data?.member_id} />
          </div>
          <div className="col-md-4 col-lg-3 col-sm-6 col-12">
            <DetailItem label="Email Id" value={resource_data?.email_id} />
          </div>
          <div className="col-md-4 col-lg-3 col-sm-6 col-12">
            <DetailItem label="Submitted" value={resource_data?.submitted_at} />
          </div>
        </div>

        <>
          {isActionTakenByAdmin ? (
            <div>
              <div className="text-14-500-18 color-text-blue cmb-18">
                Admin Review Details :
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem label="Admin" value={admin_data?.name} />
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem
                    label="Submitted Documents"
                    type="url"
                    fileName={admin_data?.admin_document}
                    handleFileDownload={handleFileDownload}
                    value={admin_data?.admin_document}
                    filePath={requestDataPath}
                  />
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem
                    label="Status"
                    value={getStatus(admin_data?.admin_status, 'request')}
                    labelClassName={getStatusColor(admin_data?.admin_status)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-sm-12 col-12">
                  <DetailItem
                    label="Admin Comment"
                    value={admin_data?.admin_comment}
                  />
                </div>
              </div>
            </div>
          ) : (
            isAdmin && (
              <div>
                <ActionForm
                  initialValues={initialValues}
                  // validationSchema={validationSchema}
                  isRejecting={isRejecting}
                  setIsRejecting={setIsRejecting}
                  handleReject={handleReject}
                  handleApproveRequest={handleApproveRequest}
                  onHide={onHide}
                  btnLoading={isLoading}
                />
              </div>
            )
          )}
        </>

        <div>
          {isActionTakenBySuperAdmin ? (
            <div>
              <div className="text-14-500-18 color-text-blue cmb-18">
                Super Admin Review Details :
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem label="Super Admin" value={sadmin_data?.name} />
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem
                    label="Submitted Documents"
                    type="url"
                    fileName={sadmin_data?.sadmin_document}
                    handleFileDownload={handleFileDownload}
                    value={sadmin_data?.sadmin_document}
                    filePath={requestDataPath}
                  />
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem
                    label="Status"
                    value={getStatus(sadmin_data?.sadmin_status, 'request')}
                    labelClassName={getStatusColor(sadmin_data?.sadmin_status)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-sm-12 col-12">
                  <DetailItem
                    label="Super Admin Comment"
                    value={sadmin_data?.sadmin_comment}
                  />
                </div>
              </div>

              <div className="d-flex gap-3">
                <Button
                  btnStyle="primary-outline"
                  className="h-35 text-14-400 gap-2"
                  text="Preview Certificate"
                  icon={<i className="bi bi-eye" />}
                  onClick={() => handleView(certificate_file)}
                />
                <Button
                  text="Cancel"
                  btnStyle="light-outline"
                  className="h-37 text-14-500 cps-20 cpe-20"
                  type="button"
                  onClick={onHide}
                />
              </div>
            </div>
          ) : (
            isSuperAdmin && (
              <div>
                <ActionForm
                  initialValues={initialValues}
                  // validationSchema={validationSchema}
                  isRejecting={isRejecting}
                  setIsRejecting={setIsRejecting}
                  handleReject={handleReject}
                  handleApproveRequest={handleApproveRequest}
                  onHide={onHide}
                  btnLoading={isLoading}
                />
              </div>
            )
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ActionFormPopup;
